import React, { useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';

import { InteractionStatus } from '@azure/msal-browser';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';

import { LockOutlined } from '@ant-design/icons';
import { Button, Col, Row } from 'antd';

import { _loginRequest } from '../../providers/authentication-provider';
import { useLogin } from './hooks/useLogin';

import './login-page.scss';

import bvLogo from '../../assets/images/bv-logo.png';

import BVSpinLoader from '../../common/components/BVSpinLoader/bv-spin-loader';
import BVLoginTemplate from '../../common/templates/BVLoginTemplate/bv-login-template';

const LoginPage: React.FunctionComponent = () => {
	const { instance, inProgress } = useMsal();
	const { handleSalesAgent, salesAgent, salesAgentLoading } = useLogin();
	const isAuthenticated = useIsAuthenticated();
	const history = useHistory();

	const calledRef = useRef(false);

	useEffect(() => {
		if (!isAuthenticated) return;
		if (calledRef.current) return;

		calledRef.current = true;
		void handleSalesAgent();
	}, [isAuthenticated, handleSalesAgent]);

	useEffect(() => {
		if (!salesAgent) return;
		history.replace('/');
	}, [salesAgent, history]);

	return (
		<BVLoginTemplate>
			<div className="login-container">
				<Row justify={'center'} align={'middle'} style={{ height: '100%' }}>
					<Col span={24}>
						<img src={bvLogo} alt={'Bulgari'} />

						{(inProgress === InteractionStatus.Startup ||
							inProgress === InteractionStatus.HandleRedirect ||
							inProgress === InteractionStatus.Login ||
							salesAgentLoading) && (
							<div className="authentication-loading">
								<BVSpinLoader
									style={{ fontSize: '6rem', marginBottom: '35px' }}
								/>

								<h1>{'Access in progress...'}</h1>
							</div>
						)}

						{inProgress !== InteractionStatus.Startup &&
							inProgress !== InteractionStatus.HandleRedirect &&
							inProgress !== InteractionStatus.Login &&
							!salesAgentLoading && (
								<React.Fragment>
									<h2>{'Login into Your Account'}</h2>

									<Button
										type="primary"
										disabled={isAuthenticated}
										icon={<LockOutlined />}
										size={'large'}
										onClick={() => instance.loginRedirect(_loginRequest)}
									>
										Login
									</Button>
								</React.Fragment>
							)}
					</Col>
				</Row>
			</div>
		</BVLoginTemplate>
	);
};

export default LoginPage;
